// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { GetSupports } from '../../../apis/base';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { getSupportListActions } = actionCreatorsList;

const outputActions = {
  success: getSupportListActions.success,
  failure: getSupportListActions.failure
};

type RequestActionTypes = ActionType<typeof getSupportListActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

const getSupportListEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      getType(getSupportListActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      return GetSupports()
        .then(response => {
          return outputActions.success({ ...response.data })
        })
        .catch((error: AxiosError) => {
          console.log(error)
          return outputActions.failure({ error });
        });
    })
  );
};

export { getSupportListEpic as default };

